import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Heading, { HeadingTypes } from '../Heading/Heading';
import Image from '../Image/Image';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SbImage from '../SbImage/SbImage';
import Container from '../Utils/Container/Container';

interface PageHeroVariantThreeBlokProps extends Blok {
  image: StoryblokAsset;
  arrow_image?: StoryblokAsset;
  heading: string;
  body?: string;
  cta?: Blok[];
}

interface PageHeroVariantThreeProps {
  blok: PageHeroVariantThreeBlokProps;
}

const PageHeroVariantThree: React.FC<PageHeroVariantThreeProps> = ({
  blok,
}) => {
  const { image, arrow_image, heading, body = undefined, cta = [] } = blok;

  return (
    <section className="relative overflow-hidden">
      <>{/*-- gradient overlay and arrow --*/}</>
      <div className="relative flex items-center">
        <Container className="">
          <Grid gapX="gap-x-[24px]" gapY="gap-y-0">
            <Col
              span={{
                default: 12,
                sm: 12,
                md: 12,
                lg: 8,
                xl: 8,
                xxl: 6,
              }}
            >
              <div className="relative z-10 flex flex-col items-center justify-center gap-y-12 lg:items-start py-16 sm:py-24 lg:pt-32 lg:pb-[10rem] xl:pb-[13rem]">
                <div className="flex flex-col items-center justify-center space-y-8 text-center lg:items-start lg:text-left">
                  {heading && (
                    <Heading text={heading} headingType={HeadingTypes.h1} />
                  )}
                  {body && <p className="text-text/body text-xl">{body}</p>}
                </div>
                {cta?.length &&
                  cta.map((cta: Blok) => (
                    <StoryblokComponent
                      blok={{ ...cta, size: ButtonSize.XL }}
                      key={cta._uid}
                    />
                  ))}
              </div>
            </Col>
            <Col
              span={{
                default: 12,
                sm: 12,
                md: 12,
                lg: 4,
                xl: 4,
                xxl: 6,
              }}
            >
              {image?.filename && (
                <div className="relative h-full flex items-end">
                  <SbImage
                    asset={image}
                    options={{
                      objectFit: 'contain',
                      objectPosition: 'bottom',
                      className:
                        'lg:absolute left-0 right-0 bottom-0 mx-auto h-full lg:max-h-[90%]',
                    }}
                  />
                </div>
              )}
            </Col>

            <div className="absolute right-0 bottom-0 left-0 overflow-hidden z-0 pointer-events-none">
              {arrow_image?.filename && (
                <div className="hidden lg:flex items-end lg:h-full lg:pt-16 lg:-translate-x-8 2xl:-translate-x-12">
                  <SbImage
                    asset={arrow_image}
                    options={{
                      className:
                        '!h-[auto] lg:max-w-[42em] xl:max-w-[55em] 2xl:max-w-[60em]',
                    }}
                  />
                </div>
              )}
            </div>
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(PageHeroVariantThree));
